/**
 * Product page share button: Web Share API with clipboard fallback.
 */
(function initProductShare() {
  if (document.documentElement.dataset.productShareInit === 'true') return;
  document.documentElement.dataset.productShareInit = 'true';

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-share-button]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const url = window.location.href;
    const title = button.dataset.shareTitle || document.title;
    const feedback = button.querySelector('[data-share-feedback]');
    const copiedLabel = button.dataset.copiedLabel || 'Link copied';

    const showCopied = () => {
      if (!(feedback instanceof HTMLElement)) return;
      feedback.textContent = copiedLabel;
      feedback.classList.remove('visually-hidden');
      window.setTimeout(() => {
        feedback.textContent = '';
        feedback.classList.add('visually-hidden');
      }, 2000);
    };

    try {
      if (navigator.share) {
        await navigator.share({ title, url });
        return;
      }

      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
        showCopied();
      }
    } catch (error) {
      if (error?.name === 'AbortError') return;
    }
  });
})();
